import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-temperature-template',
  templateUrl: './temperature-template.component.html',
  styleUrls: ['./temperature-template.component.less']
})
export class TemperatureTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
